import { FC, useRef, useState } from 'react';
import { IonButton, IonPopover } from '@ionic/react';
import { DuoFileLinesIcon } from '../../../theme/Icons';
import { INoteTemplate } from './TemplatesConfig';
import { MenuItem } from '../../../components/MenuItem';

export type INoteTemplateMenu = {
    templates: INoteTemplate[];
    onItemClick: (template: INoteTemplate) => void;
    hasButtons?: boolean;
};

export const NoteTemplateMenu: FC<INoteTemplateMenu> = ({ templates, onItemClick, hasButtons }) => {
    const popover = useRef<HTMLIonPopoverElement>(null);
    const [popoverOpen, setPopoverOpen] = useState(false);

    const openPopover = (event: React.MouseEvent<HTMLIonButtonElement>) => {
        popover.current!.event = event;
        setPopoverOpen(true);
    };

    return (
        <>
            <IonButton
                fill="outline"
                onClick={openPopover}
                data-id="note-templates-popover-trigger"
            >
                {hasButtons ?  (
                    '🙋 More Help Requests'
                ) : (
                    <><DuoFileLinesIcon slot="start" />&nbsp;&nbsp;Use A Template</>
                )}
            </IonButton>
            <IonPopover
                reference="trigger"
                side="bottom"
                alignment="start"
                style={{'--width': 'fit-content'}}
                ref={popover}
                keepContentsMounted // otherwise sometimes opens off the screen on mobile
                isOpen={popoverOpen}
                onDidDismiss={() => setPopoverOpen(false)}
            >
                {templates.map((template, i) => (
                    <MenuItem
                        key={i}
                        label={template.label}
                        data-id={template.templateId}
                        onClick={() => {
                            setPopoverOpen(false);
                            onItemClick(template);
                        }}
                    />
                ))}
            </IonPopover>
        </>
    );
};
